import React from "react";

import TablePagination from "@material-ui/core/TablePagination";
import PaginationActions from "./PaginationActions";

class Pagination extends React.Component {
  render() {
    const {
      count,
      rowsPerPage,
      page,
      onChangePage,
      onChangeRowsPerPage,
      rowsPerPageOptions,
      hasPagination,
    } = this.props;

    if (hasPagination) {
      return (
        <TablePagination
          labelRowsPerPage={null}
          component="div"
          rowsPerPageOptions={rowsPerPageOptions}
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            native: true,
          }}
          onChangePage={(e, page) => onChangePage({ page })}
          onChangeRowsPerPage={(e) =>
            onChangeRowsPerPage({ rowsPerPage: +e.target.value, page: 0 })
          }
          ActionsComponent={PaginationActions}
        />
      );
    }

    return null;
  }
}

export default Pagination;
